import { useEffect, useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { getPromoAvailable } from '../api/promo'

// Промокоды открыты не всем: настройка «Доступ» в админке (по умолчанию —
// только сотрудники). Ответ кэшируем на юзера: поле стоит в нескольких местах
// (тарифы, докупка, кабинет), а настройка меняется редко — один запрос на сессию.
const cache = new Map<string, Promise<boolean>>()

export function usePromoAvailable(): boolean {
	const { user } = useAuth()
	const uid = user?.id ? String(user.id) : ''
	// Ответ помним вместе с юзером: сменился аккаунт — прежний ответ не годится
	const [state, setState] = useState<{ uid: string; available: boolean } | null>(null)

	useEffect(() => {
		if (!uid) return
		let alive = true
		let req = cache.get(uid)
		if (!req) {
			req = getPromoAvailable()
				.then((r) => Boolean(r.available))
				.catch(() => {
					cache.delete(uid)
					return false
				})
			cache.set(uid, req)
		}
		void req.then((available) => {
			if (alive) setState({ uid, available })
		})
		return () => {
			alive = false
		}
	}, [uid])

	return Boolean(uid && state?.uid === uid && state.available)
}
